import { css } from 'emotion'

export const NewMessageEditorStyles = css`
  .ReplyMessageCard {
    margin-bottom: 8px;
  }
`
